
import jsPDF from 'jspdf';
import { PDF_CONFIG, PDF_COLORS } from './constants';

export const addHeader = (
  pdf: jsPDF, 
  pageWidth: number, 
  margin: number
): number => {
  // Header background
  pdf.setFillColor(...PDF_COLORS.lightGray);
  pdf.rect(0, 0, pageWidth, 50, 'F');
  
  // Title
  pdf.setTextColor(...PDF_COLORS.primary);
  pdf.setFontSize(PDF_CONFIG.fonts.sizes.title);
  pdf.setFont('helvetica', 'bold');
  pdf.text('RELATÓRIO PSICOLÓGICO ULTRA-DETALHADO', margin, 25);
  
  // Subtitle
  pdf.setTextColor(...PDF_COLORS.text);
  pdf.setFontSize(PDF_CONFIG.fonts.sizes.subtitle);
  pdf.setFont('helvetica', 'normal');
  pdf.text('Análise Avançada de Personalidade - Modelo OpenAI o3', margin, 35);
  
  return 60; // Return new yPosition
};

export const addMetadataSection = (
  pdf: jsPDF,
  pageWidth: number,
  margin: number,
  yPosition: number,
  insightId: string,
  createdAt: string,
  userProfile?: { name?: string; email?: string }
): number => {
  const contentWidth = pageWidth - (margin * 2);
  
  pdf.setFillColor(...PDF_COLORS.accent);
  pdf.rect(margin, yPosition, contentWidth, 40, 'F');
  
  pdf.setTextColor(...PDF_COLORS.white);
  pdf.setFontSize(14);
  pdf.setFont('helvetica', 'bold');
  pdf.text('INFORMAÇÕES DO RELATÓRIO', margin + 10, yPosition + 15);
  
  pdf.setFontSize(10);
  pdf.setFont('helvetica', 'normal');
  pdf.text(`ID da Análise: ${insightId.slice(0, 8)}`, margin + 10, yPosition + 25);
  pdf.text(`Data de Geração: ${new Date(createdAt).toLocaleDateString('pt-BR')}`, margin + 10, yPosition + 32);
  
  if (userProfile?.name) {
    pdf.text(`Usuário: ${userProfile.name}`, margin + 100, yPosition + 25);
  }
  
  return yPosition + 55;
};

export const addIntroduction = (
  pdf: jsPDF,
  pageWidth: number,
  margin: number,
  yPosition: number
): number => {
  const contentWidth = pageWidth - (margin * 2);
  
  pdf.setTextColor(...PDF_COLORS.text);
  pdf.setFontSize(16);
  pdf.setFont('helvetica', 'bold');
  pdf.text('SOBRE ESTE RELATÓRIO', margin, yPosition);
  yPosition += 10;

  pdf.setFontSize(10);
  pdf.setFont('helvetica', 'normal');
  const introText = 'Este relatório foi gerado utilizando inteligência artificial avançada (Modelo OpenAI o3) para fornecer uma análise psicológica profunda e personalizada baseada nos resultados do teste de personalidade Big Five. O conteúdo apresenta insights únicos sobre traços de personalidade, padrões comportamentais e recomendações para desenvolvimento pessoal.';
  
  const wrappedIntro = pdf.splitTextToSize(introText, contentWidth);
  pdf.text(wrappedIntro, margin, yPosition);
  
  return yPosition + (wrappedIntro.length * 4) + 15;
};

export const addFooters = (
  pdf: jsPDF,
  pageWidth: number,
  pageHeight: number,
  margin: number
): void => {
  const totalPages = pdf.getNumberOfPages();
  
  for (let i = 1; i <= totalPages; i++) {
    pdf.setPage(i);
    
    // Footer line
    pdf.setDrawColor(...PDF_COLORS.lightGray);
    pdf.line(margin, pageHeight - 25, pageWidth - margin, pageHeight - 25);
    
    // Footer text
    pdf.setTextColor(...PDF_COLORS.text);
    pdf.setFontSize(PDF_CONFIG.fonts.sizes.footer);
    pdf.setFont('helvetica', 'normal');
    pdf.text('Vive Calme - Análise de Personalidade com IA', margin, pageHeight - 15);
    pdf.text(`Página ${i} de ${totalPages}`, pageWidth - margin - 30, pageHeight - 15);
    pdf.text(`Gerado em ${new Date().toLocaleDateString('pt-BR')}`, pageWidth - margin - 50, pageHeight - 10);
  }
};
